// Tokens de design do módulo Financeiro — fonte única de cor e formatação.
// Regra de cor: verde/vermelho/âmbar carregam SIGNIFICADO financeiro (entra/sai,
// +/−, atenção). A cor de ÁREA (roxo, ciano, rosa…) vive só no header/badge —
// nunca pinta número nem barra de dado. Assim a cor sempre informa.

export const FIN = {
  ink: '#0F172A', // texto forte / números
  muted: '#64748B', // subtítulo
  faint: '#94A3B8', // metadados, %, contagens
  pos: '#16A34A', // receita / entrada / positivo
  neg: '#DC2626', // despesa / saída / negativo
  warn: '#D97706', // vencido / atenção
  info: '#1B88F5', // neutro de marca / saldo
  hair: 'rgba(15,23,42,0.06)', // divisórias
  track: 'rgba(15,23,42,0.05)', // trilho de barra
  line: '#E2E8F0', // borda de pill / input / card
  lineHover: '#CBDDEF', // hover de pill
  blueSoft: '#E9F4FD', // avatar / item ativo
};

// Raios padronizados (a referência usa 9px em pill/input, 14-16px em card).
export const RADII = { pill: '10px', inp: '10px', card: '14px' };

export const MESES_ABBR = [
  'Jan',
  'Fev',
  'Mar',
  'Abr',
  'Mai',
  'Jun',
  'Jul',
  'Ago',
  'Set',
  'Out',
  'Nov',
  'Dez',
];

export const brlCompact = (v: number) => {
  const abs = Math.abs(v);
  if (abs >= 1_000_000) return `R$ ${(v / 1_000_000).toFixed(1).replace('.', ',')}M`;
  if (abs >= 1_000) return `R$ ${(v / 1_000).toFixed(0)}k`;
  return `R$ ${v.toFixed(0)}`;
};

export const fmtPct = (v: number) => `${v.toFixed(1).replace('.', ',')}%`;
export const pct = (parte: number, todo: number) => (todo > 0 ? (parte / todo) * 100 : 0);

// Mascara de documento: 14 digitos -> CNPJ, 11 -> CPF, senao devolve cru.
export const fmtDoc = (doc?: string | null): string => {
  const d = (doc || '').replace(/\D/g, '');
  if (d.length === 14) return d.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/, '$1.$2.$3/$4-$5');
  if (d.length === 11) return d.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})$/, '$1.$2.$3-$4');
  return doc || '';
};
